const Component = () => {
    return (
        <div id="info_coapplicant" className="pop_disable_bg">
            <div className="coApplicant_pop">
                <div className="pop_head">Co-Applicant Application</div>
                <div className="pop_contentArea">
                    <div className="pop_contentHead">Please fill a new application for the Co-Applicant having the same property address.</div>
                </div>
                <div className="pop_buttonLabel">
                    <input type="button" value="Close" className="pop_button" onClick={() => window.hide('info_coapplicant')} />
                </div>
            </div>
        </div>
    );
};

export default Component;